export default __webpack_public_path__ + "static/media/4.6793ebda.jpg";